import { useState, useEffect } from 'react'
import { Box, IconButton } from '@mui/material'
import { ViewDay, CalendarMonth } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import SelectProtocolByDay from './SelectProtocolByDay'
import SelectProtocolByMonth from './SelectProtocolByMonth'
import { protocolsDate } from '@services/date/date.models'
import { useAtom } from 'jotai'
import { useUserRoles } from '@services/token/token.hooks'

function SelectProtocol() {
  const [view, setView] = useState<'day' | 'month' | 'search'>('day')
  const [, setDate] = useAtom(protocolsDate)
  const { isTechnician } = useUserRoles()
  const navigate = useNavigate()

  // Redirect technicians trying to access protocols
  useEffect(() => {
    if (isTechnician()) {
      navigate('/helpdesk/tickets', { replace: true })
    }
  }, [isTechnician, navigate])

  // If user is a technician, don't show the protocol list
  if (isTechnician()) {
    return null
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box sx={{ marginBottom: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton color='primary' onClick={() => setView('day')}>
          <ViewDay />
        </IconButton>
        <IconButton color='primary' onClick={() => setView('month')}>
          <CalendarMonth />
        </IconButton>
      </Box>
      {(() => {
        switch (view) {
          case 'month':
            return (
              <SelectProtocolByMonth
                onDateClick={(data) => {
                  setView('day')
                  setDate(data)
                }}
              />
            )
          default:
            return <SelectProtocolByDay />
        }
      })()}
    </Box>
  )
}

export default SelectProtocol
